export const resetPasswordData = {
    title: 'Reset Password Component',
    message: {
    nodeType: 'document',
    data: {},
    content: {
        nodeType: 'unordered-list',
        data: {},
        content: [
            {
            nodeType: 'list-item',
            data: {},
            content: [
                {
                nodeType: 'paragraph',
                data: {},
                content: [
                    {
                    nodeType: 'text',
                    value: 'Must be longer than 12 characters',
                    marks: [],
                    data: {}
                    }
                ]
                }
            ]
            },
            {
            nodeType: 'list-item',
            data: {},
            content: [
                {
                nodeType: 'paragraph',
                data: {},
                content: [
                    {
                    nodeType: 'text',
                    value: '1 uppercase and 1 lowercase letter',
                    marks: [],
                    data: {}
                    }
                ]
                }
            ]
            },
            {
            nodeType: 'list-item',
            data: {},
            content: [
                {
                nodeType: 'paragraph',
                data: {},
                content: [
                    {
                    nodeType: 'text',
                    value: '1 special character (e.g., !@#$%^&*)',
                    marks: [],
                    data: {}
                    }
                ]
                }
            ]
            },
            {
            nodeType: 'list-item',
            data: {},
            content: [
                {
                nodeType: 'paragraph',
                data: {},
                content: [
                    {
                    nodeType: 'text',
                    value: '1 number (0-9)',
                    marks: [],
                    data: {}
                    }
                ]
                }
            ]
            },
            {
            nodeType: 'list-item',
            data: {},
            content: [
                {
                nodeType: 'paragraph',
                data: {},
                content: [
                    {
                    nodeType: 'text',
                    value: 'Does not contain part of username',
                    marks: [],
                    data: {}
                    }
                ]
                }
            ]
            },
            {
            nodeType: 'list-item',
            data: {},
            content: [
                {
                nodeType: 'paragraph',
                data: {},
                content: [
                    {
                    nodeType: 'text',
                    value: 'Not any recently used passwords\n',
                    marks: [],
                    data: {}
                    }
                ]
                }
            ]
            }
        ]
    }
    },
    cancelButtonLabel: 'Cancel',
    resetButtonLabel: 'Reset'
}
